export default __webpack_public_path__ + "images/Bubble-Tea.54444b.jpg";